import { createQueryKeys } from "@lukemorales/query-key-factory";
import api from "utils/api";

import { endpoints } from "utils/endpoints";
import { IListResponse } from "common/models/GridModels";
import { PostModel } from "common/models/BaseModel";
import {
  IMaterialTypeRanking,
  IMaterialTypeRankingFilter,
  IMemberTypeRanking,
  IMemberTypeRankingFilter,
  IMostActiveMembers,
  IMostActiveMembersGridFilter,
  ITopFrequentlyUsedBooks,
  ITopFrequentlyUsedBooksGridFilter,
} from "./types";

export const topBooksPerformance = createQueryKeys("topBooksPerformance", {
  getTopFrequentlyUsedBooks: (
    postModel: PostModel<ITopFrequentlyUsedBooksGridFilter>,
  ) => ({
    queryKey: [postModel, "topFrequentlyUsedBooks"],
    queryFn: () =>
      api.post<IListResponse<ITopFrequentlyUsedBooks>>(
        endpoints.dashboard.getTopFrequentlyUsedBooks,
        postModel,
      ),
  }),

  getMostActiveMembers: (
    postModel: PostModel<IMostActiveMembersGridFilter>,
  ) => ({
    queryKey: [postModel, "mostActiveMembers"],
    queryFn: () =>
      api.post<IListResponse<IMostActiveMembers>>(
        endpoints.dashboard.getMostActiveMembers,
        postModel,
      ),
  }),

  getMemberTypeRanking: (filter: IMemberTypeRankingFilter) => ({
    queryKey: [filter, "memberTypeRanking"],
    queryFn: () =>
      api.post<IMemberTypeRanking[]>(
        endpoints.dashboard.getMemberTypeRanking,
        filter,
      ),
  }),

  getMaterialTypeRanking: (filter: IMaterialTypeRankingFilter) => ({
    queryKey: [filter, "materialTypeRanking"],
    queryFn: () =>
      api.post<IMaterialTypeRanking[]>(
        endpoints.dashboard.getMaterialTypeRanking,
        filter,
      ),
  }),
});
